import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/Home'
import Intro from '@/components/about/Intro'
import Concept from '@/components/about/Concept'
import Competitive from '@/components/about/Competitive'
import Milestone from '@/components/about/Milestone'
import SocialResponsibility from '@/components/about/SocialResponsibility'
import News from '@/components/about/News'
import Products from '@/components/product/Products'
import Workarea from '@/components/joinus/Workarea'
import Restaurant from '@/components/joinus/Restaurant'
import BasketballClub from '@/components/joinus/BasketballClub'
import YogaClub from '@/components/joinus/YogaClub'
import Recruit from '@/components/joinus/Recruit'
import Branch from '@/components/contactus/Branch'
import Information from '@/components/contactus/Information'
import Sitemap from '@/components/Sitemap'

Vue.use(Router)

export default new Router({
  mode: 'hash',
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  routes: [
    {
      path: '/',
      name: '首頁',
      component: Home,
    },
    {
      path: '/sitemap',
      name: '網站導覽',
      component: Sitemap,
      meta: { title: '網站導覽' }
    },
    {
      path: '/about/intro',
      name: '公司簡介',
      component: Intro,
      meta: { title: '關於白金' }
    },
    {
      path: '/about/concept',
      name: '經營理念',
      component: Concept,
      meta: { title: '關於白金' }
    },
    {
      path: '/about/competitive',
      name: '核心競爭力',
      component: Competitive,
      meta: { title: '關於白金' }
    },
    {
      path: '/about/milestone',
      name: '企業沿革',
      component: Milestone,
      meta: { title: '關於白金' }
    },
    {
      path: '/about/social-responsibility',
      name: '企業社會責任',
      component: SocialResponsibility,
      meta: { title: '關於白金' }
    },
    {
      path: '/about/news',
      name: '產業新聞',
      component: News,
      meta: { title: '關於白金' }
    },
    {
      path: '/products',
      name: '產品與服務',
      component: Products,
      meta: { title: '產品與服務' }
    },
    {
      path: '/joinus/workarea',
      name: '工作環境',
      component: Workarea,
      meta: { title: '人才招募' }
    },
    {
      path: '/joinus/restaurant',
      name: '餐廳環境',
      component: Restaurant,
      meta: { title: '人才招募' }
    },
    {
      path: '/joinus/basketballclub',
      name: '籃球社',
      component: BasketballClub,
      meta: { title: '人才招募' }
    },
    {
      path: '/joinus/yogaclub',
      name: '瑜珈社',
      component: YogaClub,
      meta: { title: '人才招募' }
    },
    {
      path: '/joinus/recruit',
      name: '加入白金',
      component: Recruit,
      meta: { title: '人才招募' }
    },
    {
      path: '/contactus/branch',
      name: '全球據點',
      component: Branch,
      meta: { title: '聯絡我們' }
    },
    {
      path: '/contactus/information',
      name: '聯絡方式',
      component: Information,
      meta: { title: '聯絡我們' }
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js